import React from "react";
import { CalendarDays, Star } from "lucide-react";
import { SectionFrame } from "./SectionFrame";
import { StatusBadge } from "../../StatusBadge";

function fmtHours(minutes) {
  return (minutes / 60).toFixed(1);
}

/** Monthly Record - Schedule section (spec P0-A): the employee's PUBLISHED shift
 * assignments for the selected period only - never unrelated employees, never DRAFT
 * assignments that could still change. */
export const ScheduleSection = ({ data, loading, error, onRetry }) => {
  const assignments = data?.assignments || [];
  return (
    <SectionFrame
      title="Schedule" icon={CalendarDays} testId="monthly-schedule-section"
      loading={loading} error={error} onRetry={onRetry}
      isEmpty={assignments.length === 0}
      emptyMessage="No published schedule exists for this period."
    >
      <p className="text-xs text-slate-500 mb-3" data-testid="monthly-schedule-total-hours">
        Total scheduled: {fmtHours(data?.total_scheduled_minutes || 0)} hours across {assignments.length} shift(s)
      </p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead className="bg-slate-50 text-slate-500 text-left">
            <tr>
              <th className="px-3 py-2 font-medium">Date</th>
              <th className="px-3 py-2 font-medium">Shift</th>
              <th className="px-3 py-2 font-medium">Store / Role</th>
              <th className="px-3 py-2 font-medium">Version</th>
              <th className="px-3 py-2 font-medium">Published</th>
              <th className="px-3 py-2 font-medium">Acknowledgment</th>
            </tr>
          </thead>
          <tbody>
            {assignments.map((a) => (
              <tr key={a.id} className="border-t border-slate-100" data-testid={`monthly-schedule-row-${a.id}`}>
                <td className="px-3 py-2 font-medium text-slate-700">{a.date}</td>
                <td className="px-3 py-2 text-slate-600">
                  {a.start_time}–{a.end_time}{a.crosses_midnight && <span className="text-amber-600 font-semibold"> (+1 day)</span>}
                  {a.is_qualifying_shift_template && <Star size={12} className="inline ml-1 text-amber-500" data-testid={`monthly-schedule-qualifying-${a.id}`} />}
                  {a.shift_template_code && <p className="text-[11px] text-slate-400">{a.shift_template_code}</p>}
                </td>
                <td className="px-3 py-2 text-slate-600">{a.store_location}<p className="text-[11px] text-slate-400">{a.role || "-"}</p></td>
                <td className="px-3 py-2 text-slate-500">v{a.schedule_version ?? "-"}</td>
                <td className="px-3 py-2 text-slate-500">{a.published_at ? new Date(a.published_at).toLocaleDateString() : "-"}</td>
                <td className="px-3 py-2"><StatusBadge status={a.acknowledgment_status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SectionFrame>
  );
};
